export default {
  /**
   * Concepts
   */
  concepts: {
    'pokemon': 'pokémon',
    'type': 'type | types',
    'color': 'color | colors',
    'sprite': 'sprite | sprites',
    'evolution': 'evolution | evolutions',
    'attack-mode': 'attack mode | attack modes',
    'stat': 'stat | stats',
    'pot': 'pot | pots',
    'name': 'name | names',
    'base': 'base',
    'bonus': 'bonus | bonuses',
    'iv-range': 'IV range',
    'attack': 'attack',
    'wait': 'wait',
    'learnable': 'learnable',
    'bingo-bonus': 'bingo bonus',
    'slot': 'slot | slots',
    'move': 'move | moves',
    'dish': 'dish | dishes',
    'quality': 'quality | qualities',
    'chance': 'chance | chances',
    'advanced': 'advanced',
    'summonable': 'summonable',
    'pokemon-filter': 'pokémon filter',
    'picture': 'picture | pictures',
    'ingredient': 'ingredient | ingredients',
    'recipe': 'recipe | recipes',
    'combination': 'combination | combinations',
  },

  /**
   * Pokemon
   */
  pokemon: {
    'Bulbasaur': 'Bulbasaur',
    'Ivysaur': 'Ivysaur',
    'Venusaur': 'Venusaur',
    'Charmander': 'Charmander',
    'Charmeleon': 'Charmeleon',
    'Charizard': 'Charizard',
    'Squirtle': 'Squirtle',
    'Wartortle': 'Wartortle',
    'Blastoise': 'Blastoise',
    'Caterpie': 'Caterpie',
    'Metapod': 'Metapod',
    'Butterfree': 'Butterfree',
    'Weedle': 'Weedle',
    'Kakuna': 'Kakuna',
    'Beedrill': 'Beedrill',
    'Pidgey': 'Pidgey',
    'Pidgeotto': 'Pidgeotto',
    'Pidgeot': 'Pidgeot',
    'Rattata': 'Rattata',
    'Raticate': 'Raticate',
    'Spearow': 'Spearow',
    'Fearow': 'Fearow',
    'Ekans': 'Ekans',
    'Arbok': 'Arbok',
    'Pikachu': 'Pikachu',
    'Raichu': 'Raichu',
    'Sandshrew': 'Sandshrew',
    'Sandslash': 'Sandslash',
    'Nidoran♀': 'Nidoran♀',
    'Nidorina': 'Nidorina',
    'Nidoqueen': 'Nidoqueen',
    'Nidoran♂': 'Nidoran♂',
    'Nidorino': 'Nidorino',
    'Nidoking': 'Nidoking',
    'Clefairy': 'Clefairy',
    'Clefable': 'Clefable',
    'Vulpix': 'Vulpix',
    'Ninetales': 'Ninetales',
    'Jigglypuff': 'Jigglypuff',
    'Wigglytuff': 'Wigglytuff',
    'Zubat': 'Zubat',
    'Golbat': 'Golbat',
    'Oddish': 'Oddish',
    'Gloom': 'Gloom',
    'Vileplume': 'Vileplume',
    'Paras': 'Paras',
    'Parasect': 'Parasect',
    'Venonat': 'Venonat',
    'Venomoth': 'Venomoth',
    'Diglett': 'Diglett',
    'Dugtrio': 'Dugtrio',
    'Meowth': 'Meowth',
    'Persian': 'Persian',
    'Psyduck': 'Psyduck',
    'Golduck': 'Golduck',
    'Mankey': 'Mankey',
    'Primeape': 'Primeape',
    'Growlithe': 'Growlithe',
    'Arcanine': 'Arcanine',
    'Poliwag': 'Poliwag',
    'Poliwhirl': 'Poliwhirl',
    'Poliwrath': 'Poliwrath',
    'Abra': 'Abra',
    'Kadabra': 'Kadabra',
    'Alakazam': 'Alakazam',
    'Machop': 'Machop',
    'Machoke': 'Machoke',
    'Machamp': 'Machamp',
    'Bellsprout': 'Bellsprout',
    'Weepinbell': 'Weepinbell',
    'Victreebel': 'Victreebel',
    'Tentacool': 'Tentacool',
    'Tentacruel': 'Tentacruel',
    'Geodude': 'Geodude',
    'Graveler': 'Graveler',
    'Golem': 'Golem',
    'Ponyta': 'Ponyta',
    'Rapidash': 'Rapidash',
    'Slowpoke': 'Slowpoke',
    'Slowbro': 'Slowbro',
    'Magnemite': 'Magnemite',
    'Magneton': 'Magneton',
    'Farfetch\'d': 'Farfetch\'d',
    'Doduo': 'Doduo',
    'Dodrio': 'Dodrio',
    'Seel': 'Seel',
    'Dewgong': 'Dewgong',
    'Grimer': 'Grimer',
    'Muk': 'Muk',
    'Shellder': 'Shellder',
    'Cloyster': 'Cloyster',
    'Gastly': 'Gastly',
    'Haunter': 'Haunter',
    'Gengar': 'Gengar',
    'Onix': 'Onix',
    'Drowzee': 'Drowzee',
    'Hypno': 'Hypno',
    'Krabby': 'Krabby',
    'Kingler': 'Kingler',
    'Voltorb': 'Voltorb',
    'Electrode': 'Electrode',
    'Exeggcute': 'Exeggcute',
    'Exeggutor': 'Exeggutor',
    'Cubone': 'Cubone',
    'Marowak': 'Marowak',
    'Hitmonlee': 'Hitmonlee',
    'Hitmonchan': 'Hitmonchan',
    'Lickitung': 'Lickitung',
    'Koffing': 'Koffing',
    'Weezing': 'Weezing',
    'Rhyhorn': 'Rhyhorn',
    'Rhydon': 'Rhydon',
    'Chansey': 'Chansey',
    'Tangela': 'Tangela',
    'Kangaskhan': 'Kangaskhan',
    'Horsea': 'Horsea',
    'Seadra': 'Seadra',
    'Goldeen': 'Goldeen',
    'Seaking': 'Seaking',
    'Staryu': 'Staryu',
    'Starmie': 'Starmie',
    'Mr. Mime': 'Mr. Mime',
    'Scyther': 'Scyther',
    'Jynx': 'Jynx',
    'Electabuzz': 'Electabuzz',
    'Magmar': 'Magmar',
    'Pinsir': 'Pinsir',
    'Tauros': 'Tauros',
    'Magikarp': 'Magikarp',
    'Gyarados': 'Gyarados',
    'Lapras': 'Lapras',
    'Ditto': 'Ditto',
    'Eevee': 'Eevee',
    'Vaporeon': 'Vaporeon',
    'Jolteon': 'Jolteon',
    'Flareon': 'Flareon',
    'Porygon': 'Porygon',
    'Omanyte': 'Omanyte',
    'Omastar': 'Omastar',
    'Kabuto': 'Kabuto',
    'Kabutops': 'Kabutops',
    'Aerodactyl': 'Aerodactyl',
    'Snorlax': 'Snorlax',
    'Articuno': 'Articuno',
    'Zapdos': 'Zapdos',
    'Moltres': 'Moltres',
    'Dratini': 'Dratini',
    'Dragonair': 'Dragonair',
    'Dragonite': 'Dragonite',
    'Mewtwo': 'Mewtwo',
    'Mew': 'Mew',
  },

  /**
   * Types
   */
  types: {
    'normal': 'normal',
    'fighting': 'fighting',
    'flying': 'flying',
    'poison': 'poison',
    'ground': 'ground',
    'rock': 'rock',
    'bug': 'bug',
    'ghost': 'ghost',
    'steel': 'steel',
    'fire': 'fire',
    'water': 'water',
    'grass': 'grass',
    'electric': 'electric',
    'psychic': 'psychic',
    'ice': 'ice',
    'dragon': 'dragon',
    'dark': 'dark',
    'fairy': 'fairy',
  },

  /**
   * Colors
   */
  colors: {
    'red': 'red',
    'blue': 'blue',
    'yellow': 'yellow',
    'gray': 'gray',
  },

  /**
   * Attack modes
   */
  'attack-modes': {
    'melee': 'melee',
    'range': 'range',
  },

  /**
   * Pots
   */
  pots: {
    'brass': 'brass',
    'bronze': 'bronze',
    'silver': 'silver',
    'gold': 'gold',
  },

  /**
   * Dishes
   */
  dishes: {
    'Mulligan Stew a la Cube': 'Mulligan Stew a la Cube',
    'Red Stew a la Cube': 'Red Stew a la Cube',
    'Blue Soda a la Cube': 'Blue Soda a la Cube',
    'Yellow Curry a la Cube': 'Yellow Curry a la Cube',
    'Gray Porridge a la Cube': 'Gray Porridge a la Cube',
    'Mouth-Watering Dip a la Cube': 'Mouth-Watering Dip a la Cube',
    'Plain Crepe a la Cube': 'Plain Crepe a la Cube',
    'Sludge Soup a la Cube': 'Sludge Soup a la Cube',
    'Mud Pie a la Cube': 'Mud Pie a la Cube',
    'Veggie Smoothie a la Cube': 'Veggie Smoothie a la Cube',
    'Honey Nectar a la Cube': 'Honey Nectar a la Cube',
    'Brain Food a la Cube': 'Brain Food a la Cube',
    'Stone Soup a la Cube': 'Stone Soup a la Cube',
    'Light-as-Air Casserole a la Cube': 'Light-as-Air Casserole a la Cube',
    'Hot Pot a la Cube': 'Hot Pot a la Cube',
    'Watt a Risotta a la Cube': 'Watt a Risotta a la Cube',
    'Get Swole Syrup a la Cube': 'Get Swole Syrup a la Cube',
    'Ambrosia of Legends a la Cube': 'Ambrosia of Legends a la Cube',
  },

  /**
   * Qualities
   */
  qualities: {
    'BASIC': 'Basic',
    'GOOD': 'Good',
    'VERY_GOOD': 'Very good',
    'SPECIAL': 'Special',
  },

  /**
   * Moves
   */
  moves: {
    'Petal Dance': 'Petal Dance',
    'Synthesis': 'Synthesis',
    'Tackle': 'Tackle',
    'Toxic': 'Toxic',
    'Vine Whip': 'Vine Whip',
    'Leech Seed': 'Leech Seed',
    'Poison Powder': 'Poison Powder',
    'Take Down': 'Take Down',
    'Mega Drain': 'Mega Drain',
    'Solar Beam': 'Solar Beam',
    'Ember': 'Ember',
    'Fire Punch': 'Fire Punch',
    'Fire Spin': 'Fire Spin',
    'Metal Claw': 'Metal Claw',
    'Scratch': 'Scratch',
    'Dragon Claw': 'Dragon Claw',
    'Flamethrower': 'Flamethrower',
    'Fire Blast': 'Fire Blast',
    'Flame Charge': 'Flame Charge',
    'Flare Blitz': 'Flare Blitz',
    'Bubble': 'Bubble',
    'Whirlpool': 'Whirlpool',
    'Withdraw': 'Withdraw',
    'Aqua Jet': 'Aqua Jet',
    'Aqua Ring': 'Aqua Ring',
    'Blizzard': 'Blizzard',
    'Surf': 'Surf',
    'Waterfall': 'Waterfall',
    'Hydro Pump': 'Hydro Pump',
    'Lunge': 'Lunge',
    'String Shot': 'String Shot',
    'Iron Defense': 'Iron Defense',
    'Electroweb': 'Electroweb',
    'Harden': 'Harden',
    'Rage Powder': 'Rage Powder',
    'Silver Wind': 'Silver Wind',
    'Poison Sting': 'Poison Sting',
    'Aerial Ace': 'Aerial Ace',
    'Agility': 'Agility',
    'Pin Missile': 'Pin Missile',
    'Gust': 'Gust',
    'Mud-Slap': 'Mud-Slap',
    'Tailwind': 'Tailwind',
    'Twister': 'Twister',
    'Whirlwind': 'Whirlwind',
    'Hurricane': 'Hurricane',
    'Heat Wave': 'Heat Wave',
    'Roost': 'Roost',
    'Sky Attack': 'Sky Attack',
    'Crunch': 'Crunch',
    'Focus Energy': 'Focus Energy',
    'Flame Wheel': 'Flame Wheel',
    'Iron Tail': 'Iron Tail',
    'Zen Headbutt': 'Zen Headbutt',
    'Fly': 'Fly',
    'Growl': 'Growl',
    'Leer': 'Leer',
    'Drill Peck': 'Drill Peck',
    'Tri Attack': 'Tri Attack',
    'Mud Bomb': 'Mud Bomb',
    'Rock Tomb': 'Rock Tomb',
    'Earthquake': 'Earthquake',
    'Sucker Punch': 'Sucker Punch',
    'Spark': 'Spark',
    'Thunder Shock': 'Thunder Shock',
    'Thunderbolt': 'Thunderbolt',
    'Volt Tackle': 'Volt Tackle',
    'Charge': 'Charge',
    'Electric Terrain': 'Electric Terrain',
    'Giga Impact': 'Giga Impact',
    'Thunder': 'Thunder',
    'Dig': 'Dig',
    'Rollout': 'Rollout',
    'Sandstorm': 'Sandstorm',
    'Night Slash': 'Night Slash',
    'Swords Dance': 'Swords Dance',
    'Flatter': 'Flatter',
    'Sing': 'Sing',
    'Sludge Bomb': 'Sludge Bomb',
    'Stealth Rock': 'Stealth Rock',
    'Supersonic': 'Supersonic',
    'Venom Drench': 'Venom Drench',
    'Rock Smash': 'Rock Smash',
    'Work Up': 'Work Up',
    'Amnesia': 'Amnesia',
    'Megahorn': 'Megahorn',
    'Taunt': 'Taunt',
    'Flash': 'Flash',
    'Light Screen': 'Light Screen',
    'Dazzling Gleam': 'Dazzling Gleam',
    'Follow Me': 'Follow Me',
    'Charm': 'Charm',
    'Roar': 'Roar',
    'Confuse Ray': 'Confuse Ray',
    'Will-O-Wisp': 'Will-O-Wisp',
    'Mega Punch': 'Mega Punch',
    'Bounce': 'Bounce',
    'Dynamic Punch': 'Dynamic Punch',
    'Play Rough': 'Play Rough',
    'Sweet Kiss': 'Sweet Kiss',
    'Leech Life': 'Leech Life',
    'U-turn': 'U-turn',
    'Nasty Plot': 'Nasty Plot',
    'Stun Spore': 'Stun Spore',
    'Bullet Seed': 'Bullet Seed',
    'Psybeam': 'Psybeam',
    'Spore': 'Spore',
    'Psychic': 'Psychic',
    'Rock Throw': 'Rock Throw',
    'Shore Up': 'Shore Up',
    'Fury Swipes': 'Fury Swipes',
    'Flail': 'Flail',
    'Icy Wind': 'Icy Wind',
    'Ice Beam': 'Ice Beam',
    'Submission': 'Submission',
    'Close Combat': 'Close Combat',
    'Cross Chop': 'Cross Chop',
    'Meditate': 'Meditate',
    'Extreme Speed': 'Extreme Speed',
    'Bulk Up': 'Bulk Up',
    'Ice Punch': 'Ice Punch',
    'Power-Up Punch': 'Power-Up Punch',
    'Barrier': 'Barrier',
    'Teleport': 'Teleport',
    'Psycho Cut': 'Psycho Cut',
    'Recover': 'Recover',
    'Shadow Ball': 'Shadow Ball',
    'Rolling Kick': 'Rolling Kick',
    'Razor Leaf': 'Razor Leaf',
    'Hyper Beam': 'Hyper Beam',
    'Self-Destruct': 'Self-Destruct',
    'Explosion': 'Explosion',
    'Rock Polish': 'Rock Polish',
    'Stomp': 'Stomp',
    'Belly Drum': 'Belly Drum',
    'Rest': 'Rest',
    'Flash Cannon': 'Flash Cannon',
    'Metal Sound': 'Metal Sound',
    'Steel Wing': 'Steel Wing',
    'Lick': 'Lick',
    'Aurora Veil': 'Aurora Veil',
    'Slam': 'Slam',
    'Acid Armor': 'Acid Armor',
    'Icicle Crash': 'Icicle Crash',
    'Rock Blast': 'Rock Blast',
    'Spikes': 'Spikes',
    'Astonish': 'Astonish',
    'Smog': 'Smog',
    'Hypnosis': 'Hypnosis',
    'Egg Bomb': 'Egg Bomb',
    'Bonemerang': 'Bonemerang',
    'Outrage': 'Outrage',
    'High Jump Kick': 'High Jump Kick',
    'Comet Punch': 'Comet Punch',
    'Drain Punch': 'Drain Punch',
    'Lava Plume': 'Lava Plume',
    'Dragon Rush': 'Dragon Rush',
    'Soft-Boiled': 'Soft-Boiled',
    'Substitute': 'Substitute',
    'Dragon Dance': 'Dragon Dance',
    'Dragon Pulse': 'Dragon Pulse',
    'Splash': 'Splash',
    'Draining Kiss': 'Draining Kiss',
    'Thunder Punch': 'Thunder Punch',
    'Transform': 'Transform',
    'Draco Meteor': 'Draco Meteor',
    'Psystrike': 'Psystrike',
  },

  /**
   * Messages
   */
  messages: {
    'see-other-pokemon': 'See other @:concepts.pokemon',
    'not-exist': 'Not exist',
    'please-enter-level': 'Please enter the level you want (from 1 to 100) :',
    'invalid-level-try-again': 'This is not a valid level. Would you like to try again?',
    'new-version-available': 'New version of PokeQuest Wiki is available!',
    'try-it-now': 'Try it now!',
    'dismiss': 'Dismiss',
    'no-internet-running-offline': 'No internet connection found. App is running in offline mode.',
    'ready-for-offline': 'PokeQuest Wiki is ready for offline use.',
    'star-me': 'Star me',
  },
}
